import React from 'react';
import CallRoundedIcon from '@mui/icons-material/CallRounded';
import MessageRoundedIcon from '@mui/icons-material/MessageRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import EventRoundedIcon from '@mui/icons-material/EventRounded';
import InsertDriveFileRoundedIcon from '@mui/icons-material/InsertDriveFileRounded';
import ScheduleSendRoundedIcon from '@mui/icons-material/ScheduleSendRounded';
import PracticeDialog from '../../Pages/PracticesPage/Components/Dialog';
import DraftPracticeForm from '../../Pages/PracticesPage/Components/DraftPracticeForm';
import AppointmentDialog from '../../Components/Dialog/AppointmentDialog';
import ActivityFormDialog from '../../Components/Dialog/ActivityFormDialog';
import AppointmentForm from '../../Pages/CustomerPage/CallSection/ResultBox/AppointmentForm';
import ManualActivityContent from '../../Components/Dialog/ManualActivityDialog/ManualActivityContent';
import RecallForm from '../../Pages/CustomerPage/CallSection/ResultBox/RecallForm';
import TouchAppRoundedIcon from '@mui/icons-material/TouchAppRounded';
import IncomingCallDialog from '../../Pages/CustomerPage/CallSection/InboundCallDialog';

export const ACTIVITY_TYPES_COLORS = {
  CALL: '#34A853',
  EMAIL: '#b00020',
  SMS: '#1D5B9D',
  APPOINTMENT: '#b00020',
  DOSSIER: '#c6cbf0',
  'MASSIVE-SMS': '#0288d1',
  MANUAL: '#f9a825',
};

export const ACTIVITY_TYPES_ICONS = {
  CALL: CallRoundedIcon,
  EMAIL: EmailRoundedIcon,
  SMS: MessageRoundedIcon,
  APPOINTMENT: EventRoundedIcon,
  DOSSIER: InsertDriveFileRoundedIcon,
  'MASSIVE-SMS': ScheduleSendRoundedIcon,
  MANUAL: TouchAppRoundedIcon,
};

export const ACTIVITY_TYPES_DIALOGS = {
  CALL: IncomingCallDialog,
  APPOINTMENT: AppointmentDialog,
  DOSSIER: PracticeDialog,
  MANUAL: function ManualActivityDialog(props) {
    return (
      <ActivityFormDialog
        {...props}
        id="manual-activity-dialog"
        title="INSERT_MANUAL_ACTIVITY"
        Icon={ACTIVITY_TYPES_ICONS.MANUAL}
        Form={ManualActivityContent}
        mapSubmit={({ activityOutcome, ...data }) => data}
      />
    );
  },
  RECALL: function RecallDialog(props) {
    return (
      <ActivityFormDialog
        {...props}
        id="recall-dialog"
        title="NEW_RECALL"
        Icon={ACTIVITY_TYPES_ICONS.CALL}
        Form={RecallForm}
      />
    );
  },
  DRAFT_PRACTICE: function DraftPracticeDialog(props) {
    return (
      <ActivityFormDialog
        {...props}
        id="draft-practice-dialog"
        title="DRAFT_PRACTICE"
        Icon={ACTIVITY_TYPES_ICONS.DOSSIER}
        Form={DraftPracticeForm}
      />
    );
  },
};

export const ACTIVITY_TYPES_FORMS = {
  CALL: RecallForm,
  APPOINTMENT: AppointmentForm,
  DOSSIER: null,
  MANUAL: ManualActivityContent,
};
